import { Box, css, styled } from '@mui/material';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { SidebarNav } from '@/components/routing/SidebarNav';
import { useUIStore } from '@/stores/useUIStore';

const StyledBox = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })<{ open: boolean }>(
  ({ theme, open }) => css`
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      width: ${open ? theme.spacing(24) : theme.spacing(8.5)};
      height: 100%;
      background-color: #f6f6f6f2;
      backdrop-filter: blur(5px);
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      transition:
        width 0.3s,
        opacity 0.3s,
        padding 0.3s;
      z-index: 10;
    }
  `,
);

export function SidebarNavigation() {
  const sidebarExpanded = useUIStore((state) => state.sidebarExpanded);

  return (
    <StyledBox open={sidebarExpanded}>
      <Header />
      <SidebarNav />
      <Footer />
    </StyledBox>
  );
}
